import { useContext, useEffect, useState } from "react";

import { IconButton } from "@material-ui/core";
import {
  Add,
  GetApp,
  EditOutlined,
  FileCopyOutlined,
  Settings,
} from "@material-ui/icons";

import {
  Container,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
} from "@material-ui/core";

import { useHistory } from "react-router";

import HeaderModule from "../../../components/header/HeaderModule";
import { PainelContainer, TableContent } from "./styles/Produto";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import Btn from "../../../components/buttons/Btn";
import TextFieldErp from "../../../components/basics/TextFieldErp";

import useProdutoController from "./controllers/ProdutoController";
import Loading from "../../../components/basics/Loading";

import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";
import { BallContainer } from "./styles/Produto";
import BigDataTable from "../../../components/tables/BigDataTable";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import SelectErp from "../../../components/basics/SelectErp";
import {
  ProdutoContext,
  ProdutoContextProvider,
} from "./contexts/ProdutoContext";
import { findLocaisEstoques } from "../../../repositories/qerpapi/erp/estoque/v1/LocalEstoqueRepository";
import { findTabelaPrecos } from "../../../repositories/qerpapi/erp/prouser/v1/TabelaPrecos";
import { findUsuarios } from "../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";
import { notify } from "../../../utils/notify";
import ModalParameters from "../../../patterns/modals/modalparameters/ModalParameters";
import TableDefault from "../../../components/grid/TableDefault";
import { GlobalVariables } from "../../../GlobalVariables";

let typingTimer = null;
const View = () => {
  const { queryParams } = useContext(QueryParamsContext);
  const {
    listStockLocations,
    setListStockLocations,
    priceTable,
    setPriceTable,
    pricesList,
    setPricesList,
    loading,
    setLoading,
  } = useContext(ProdutoContext);

  const { handleCloneProduct, getRealCost, getProductPrice, handleScaleFile } =
    useProdutoController();
  const { push } = useHistory();

  const [textFilter, setTextFilter] = useState("");
  const [showOnlyActives, setShowOnlyActives] = useState(true);
  const [urlObjects, setUrlObjects] = useState(null);
  const [stockLocationFilter, setStockLocationFilter] = useState(null);

  const [fieldsLoading, setFieldsLoading] = useState(true);

  const tabelaPrecos = queryParams.paramutilizatabelaprecos === "SIM";
  const codigoBarrasLocalEstoque =
    queryParams.codigobarraslocalestoque === "SIM";
  const utilizaBalanca = queryParams.paramutilizacodigobalanca === "SIM";
  const naoBuscaCodigo = queryParams.parambuscacodigobarras === "SIM";

  useEffect(() => {
    async function getData() {
      try {
        setFieldsLoading(true);

        const [priceTablesCallback, resultStockLocations, usersCallback] =
          await Promise.all([
            findTabelaPrecos(queryParams.empresa_cnpj),
            findLocaisEstoques(queryParams.empresa_cnpj),
            findUsuarios(
              queryParams.empresa_cnpj,
              queryParams.usuario_id,
              "grupos"
            ),
          ]);

        if (priceTablesCallback.success)
          setPricesList(
            priceTablesCallback.data.filter((current) => current.ativo === "S")
          );

        if (resultStockLocations.success) {
          let stockLocation = [
            {
              id: "",
              descricao: "Todos",
            },
          ];

          let mainIndex =
            resultStockLocations.data.length === 1
              ? 0
              : resultStockLocations.data.findIndex(
                  (current) =>
                    current.id === Number(queryParams.api_idlocalestoque_padrao)
                );

          if (mainIndex === -1) mainIndex = 0;

          stockLocation.push(resultStockLocations.data[mainIndex]);

          resultStockLocations.data.filter(
            (current) =>
              current !== stockLocation[1] &&
              current.ativo === "S" &&
              stockLocation.push(current)
          );

          setListStockLocations(stockLocation || []);
          setStockLocationFilter(stockLocation[1] || null);
        }

        if (!usersCallback.success)
          return notify("Não foi possível encontrar o grupo de usuário.");
        let blockVersions = [];
        blockVersions.push(
          GlobalVariables.systemVersions.sender,
          GlobalVariables.systemVersions.essencial,
          GlobalVariables.systemVersions.advance
        );
        const block = !blockVersions.some(
          (version) => version === queryParams.idversao
        );
        const permission =
          (usersCallback.data?.grupos || []).some(
            (el) => el.id === GlobalVariables.userGroups.master
          ) && block;
        setAbleToOpenModal(permission);
      } catch (error) {
        console.error(error);
      } finally {
        setFieldsLoading(false);
      }
    }

    if (
      !queryParams.api_idlocalestoque_padrao ||
      !queryParams.empresa_cnpj ||
      !queryParams.usuario_id
    )
      return;

    getData();
  }, [
    queryParams.api_idlocalestoque_padrao,
    queryParams.empresa_cnpj,
    queryParams.usuario_id,
    setListStockLocations,
    setPricesList,
    setLoading,
  ]);

  const columns = [
    {
      disabled: true,
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        let itemActions = [
          {
            icon: <EditOutlined />,
            name: "Editar",
            action: () =>
              push(
                "cadastro?empresa_cnpj=" +
                  queryParams.empresa_cnpj +
                  "&empresa_id=" +
                  queryParams.empresa_id,
                { item }
              ),
          },
          {
            icon: <FileCopyOutlined />,
            name: "Clonar",
            action: () => handleCloneProduct({ item }),
          },
        ];
        return <SpeedDialErp actions={itemActions} />;
      },
    },
    {
      id: "id",
      label: "ID",
      disablePadding: true,
    },
    {
      id: "codigobarras",
      label: "Cód. Barras",
      disablePadding: true,
    },
    {
      id: "descricao",
      label: "Descrição",
      disablePadding: true,
    },
    {
      disabled: true,
      id: "fornecedor",
      label: "Fornecedor",
      format: (item) => item.fornecedor_apelido || "-",
      disablePadding: true,
    },
    {
      disabled: true,
      id: "grupoestoque",
      label: "Grupo Estoque",
      format: (item) => item.grupo_estoque_descricao || "-",
      disablePadding: true,
    },

    {
      disabled: true,
      id: "custobruto",
      label: "Preço Custo",
      format: (product) =>
        getRealCost({
          custoBrutoEstoque: product.custobruto_estoque,
          freteEstoque: product.frete_estoque,
          seguroEstoque: product.seguro_estoque,
          outrasDespEstoque: product.outrasdesp_estoque,
          icmsstEstoque: product.icmsst_estoque,
          ipiEstoque: product.ipi_estoque,
          descontoEstoque: product.desconto_estoque,
          cofinsEstoque: product.cofins_estoque,
          pisEstoque: product.pis_estoque,
        }),
      disablePadding: true,
    },
    {
      disabled: true,
      id: "precovenda",
      label: "Preço de Venda",
      format: (item) => getProductPrice(item),
      disablePadding: true,
    },
    {
      disabled: true,
      id: "qtdatual",
      label: "Qtd. Estoque",
      format: (item) =>
        item.estoque_qtdeatual
          ? parseFloat(item.estoque_qtdeatual)
              .toLocaleString()
              .replace(".", ",")
          : 0,
      disablePadding: true,
    },
    stockLocationFilter?.descricao === "Todos"
      ? {
          id: "descricao_estoque",
          label: "Local Estoque",
          align: "center",
        }
      : {},
    {
      id: "produtoativo",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.produtoativo === "SIM" &&
        !(value.estoque_inativo && value.estoque_inativo === "S") ? (
          <BallContainer>
            <img src={GreenBall} alt="green-ball" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="red-ball" />
          </BallContainer>
        ),
      disablePadding: true,
    },
  ];

  const columnsForFilter = [
    "acoes",
    "id",
    "descricao",
    "fornecedor",
    "grupoestoque",
    "custobruto",
    "precovenda",
    "qtdatual",
    "produtoativo",
    "descricao_estoque",
  ];

  useEffect(() => {
    if (fieldsLoading || !stockLocationFilter) return;

    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setUrlObjects({
        stockLocation: stockLocationFilter?.id || "",
        active: showOnlyActives ? "SIM" : "NAO",
        description: encodeURIComponent(`${textFilter}`) || null,
        supplier: encodeURIComponent(`${textFilter}`) || null,
        codeBar: textFilter.toUpperCase() || null,
        productId:
          textFilter && !isNaN(textFilter.replaceAll(" ", ""))
            ? textFilter.replace(/[^0-9]/g, "")
            : null,
        priceTable: priceTable?.id || "",
      });
    }, 1500);
  }, [
    textFilter,
    showOnlyActives,
    stockLocationFilter,
    priceTable,
    fieldsLoading,
  ]);

  const [ableToOpenModal, setAbleToOpenModal] = useState(false);
  const [modalParametersOpen, setModalParametersOpen] = useState(false);

  return (
    <>
      <Loading open={loading} />
      {modalParametersOpen && (
        <ModalParameters
          open={modalParametersOpen}
          setOpen={setModalParametersOpen}
          entity="produtos"
        />
      )}
      <Loading open={loading} />
      <HeaderModule
        title="CADASTRO DE PRODUTOS"
        receivedChild={
          <Grid item>
            {ableToOpenModal && (
              <IconButton
                onClick={() => setModalParametersOpen((current) => !current)}
              >
                <Settings />
              </IconButton>
            )}
          </Grid>
        }
      />

      <PainelContainer />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid
            item
            container
            spacing={2}
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Grid item xs={12} sm={12} md={5}>
              <TextFieldErp
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Descrição, Código de Barras, Código do Produto ou por Fornecedor"
                variant="filled"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={2}>
              <SelectErp
                label="Local de estoque"
                value={stockLocationFilter}
                setValue={setStockLocationFilter}
                optionsList={listStockLocations}
                descriptionField="descricao"
                loading={fieldsLoading}
                variant="filled"
              />
            </Grid>

            {tabelaPrecos && (
              <Grid item xs={6} sm={6} md={3} lg={2}>
                <SelectErp
                  label="Tabela de preços"
                  value={priceTable}
                  setValue={setPriceTable}
                  optionsList={pricesList}
                  descriptionField="descricao"
                  loading={fieldsLoading}
                  variant="filled"
                />
              </Grid>
            )}

            <Grid item xs={6} sm={3} md={2} lg={1} xl={2}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyActives}
                    onChange={() => setShowOnlyActives((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativos"
                labelPlacement="end"
                flex-direction="row-reverse"
              />
            </Grid>
            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<Add />}
                onClick={() =>
                  push(
                    "cadastro?empresa_cnpj=" +
                      queryParams.empresa_cnpj +
                      "&empresa_id=" +
                      queryParams.empresa_id +
                      "&clearPreviusQueryParams=datanf"
                  )
                }
              />
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <TableContent>
              {!fieldsLoading && urlObjects ? (
                <BigDataTable
                  tableTitle=""
                  route="estoque/produtos/v1/porlocalestoque"
                  columns={columns.filter((column) =>
                    codigoBarrasLocalEstoque || !naoBuscaCodigo
                      ? columnsForFilter.includes(column.id)
                      : true
                  )}
                  urlObjects={urlObjects}
                />
              ) : (
                <TableDefault
                  columns={columns.filter((column) =>
                    codigoBarrasLocalEstoque || !naoBuscaCodigo
                      ? columnsForFilter.includes(column.id)
                      : true
                  )}
                  tableTitle=""
                  loading={true}
                  rowsPerPage={10}
                />
              )}
            </TableContent>
          </Grid>

          {utilizaBalanca && (
            <Grid item xs={12}>
              <Btn
                label="Gerar Arquivo Balança"
                startIcon={<GetApp />}
                onClick={() =>
                  handleScaleFile({
                    where: textFilter,
                    stockLocationFilter: stockLocationFilter?.id,
                    priceTable: priceTable?.id,
                  })
                }
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
};

const ProdutoListagem = () => (
  <ProdutoContextProvider>
    <View />
  </ProdutoContextProvider>
);

export default ProdutoListagem;
